// @mui
import Stack from '@mui/material/Stack';
//
import { Avatar, Box, Button, Menu, MenuItem, useTheme } from '@mui/material';

import { useState } from 'react';
import { useRouter } from 'src/routes/hook';
import { paths } from 'src/routes/paths';
import { useLocales } from 'src/locales';
import { NavProps } from '../types';
import NavList from './nav-list';

// ----------------------------------------------------------------------

export default function NavDesktop({ offsetTop, data }: NavProps) {
  const { t } = useLocales();
  return (
    <Stack component="nav" direction="row" spacing={4} sx={{ mr: 2.5, height: 1 }}>
      {data.map((link) => (
        <NavList key={link.title} item={link} offsetTop={offsetTop} />
      ))}
      <Stack component="a" sx={{ textDecoration: 'none' }} href={paths.contact}>
        <Button
          variant="contained"
          sx={{
            color: (theme) => theme.palette.background.paper,
            my: 'auto',
          }}
        >
          {t('Contact Us')}
        </Button>
      </Stack>
      {/* <Stack alignItems="center" justifyContent="center">
        <Box sx={{ width: 1 }}>
          <Button onClick={handleClick}>
            <Avatar sx={{ width: 35, height: 35 }} />
          </Button>
        </Box>
        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={isopen}
          onClose={handleCloseTest}
          onClick={handleCloseTest}
          PaperProps={{
            elevation: 0,
            sx: {
              padding: 1,
              overflow: 'visible',
              minWidth: 120,
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 25,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Stack> */}
    </Stack>
  );
}
